import {Box, Button, Menu, MenuItem, Typography, FormControl, InputLabel, Select} from "@material-ui/core";
import {useCallback, useRef, useEffect, useState, useMemo} from "react";
import {LicenseManager} from "ag-grid-enterprise";
import {AgGridReact} from "ag-grid-react";
import CustomCheckbox from "../../components/checkboxRenderer";
import fnOpenToast from "../../components/toast";
import "react-toastify/dist/ReactToastify.css";
import CreateDealershipDialog from "../../components/createDealershipDialog";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import EditIcon from "@material-ui/icons/Edit";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import RedoIcon from "@material-ui/icons/Redo";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import {Link as ReactLink} from "react-router-dom";
import {extractValues} from "../../utils/extractValues";
import {notifyError} from "../../utils/toast";
import {
    updateDealerships,
    deleteDealerships,
    createDealership,
    getCountriesCurrencies,
    getStates,
    getDealershipEnums,
    getDealerships,
} from "../../api";

LicenseManager.setLicenseKey(
    "Using_this_{AG_Grid}_Enterprise_key_{AG-062453}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Lucid_USA,_Inc}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{V360}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{V360}_need_to_be_licensed___{V360}_has_been_granted_a_Deployment_License_Add-on_for_{2}_Production_Environments___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{28_August_2025}____[v3]_[01]_MTc1NjMzNTYwMDAwMA==83cd4edac4587e17c3187cf63f89d914",
);

const initialValue = {
    State: {
        value: "FL",
        hasError: false,
    },
    Licensed: {
        value: false,
        hasError: false,
    },
    License: {
        value: "",
        hasError: false,
    },
    Address: {
        value: "",
        hasError: false,
    },
    City: {
        value: "",
        hasError: false,
    },
    Zip: {
        value: "",
        hasError: false,
    },
    "Name.firstName": {
        value: "",
        hasError: false,
    },
    "Name.MiddleName": {
        value: "",
        hasError: false,
    },
    "Name.LastName": {
        value: "",
        hasError: false,
    },
    remittanceResponsibility: {
        value: "",
        hasError: false,
    },
    leaseTaxesPaid: {
        value: "",
        hasError: false,
    },
    leaseTaxesRemitted: {
        value: "",
        hasError: false,
    },
    closestDeliveryLocation: {
        value: "",
        hasError: false,
    },
    PdiLocation: {
        value: "",
        hasError: false,
    },
    ID: {
        value: "",
        hasError: false,
    },
};

function Dealerships() {
    const [open, setOpen] = useState(false);
    const [enableEditing, setEnableEditing] = useState(false);
    const [rowsUpdated, setRowsUpdated] = useState(new Map());
    const [tableData, setTableData] = useState(null);
    const [licenseNumArr, setLicenseNumArr] = useState([]);
    const [licenseNumOption, setLicenseNumOption] = useState([]);
    const [licenseStateAddresses, setLicenseStateAddresses] = useState(
        new Map(),
    );
    const [constantsData, setConstantsData] = useState(null);
    const [countries, setCountries] = useState(new Map());
    const [currentCountry, setCurrentCountry] = useState("US");
    const gridRef = useRef();
    const [states, setStates] = useState(new Map());
    const [statesList, setStatesList] = useState(null);
    const [formData, setFormData] = useState(initialValue);

    const frameworkComponents = {
        checkboxRenderer: CustomCheckbox,
    };

    const [countryOption, setCountryOption] = useState([]);

    const licenseValueFormatter = (params) => {
        return params.value === true ? "Licensed" : "Unlicensed";
    };

    const iso3Codes = {
        US: "USA",
        CA: "CAN"
    };

    const columnDefs = [
        {
            headerName: "",
            checkboxSelection: true,
            headerCheckboxSelection: true,
            width: 50,
            minWidth: 50,
            maxWidth: 50,
            pinned: "left",
            lockPosition: true,
            suppressMenu: true,
            suppressSizeToFit: true,
            field: "checkboxBtn",
            filter: false,
            sortable: false,
        },
        {
            headerName: "State",
            field: "state",
            cellEditor: "agRichSelectCellEditor",
            cellEditorPopup: true,
            cellEditorParams: () => {
                return {
                    values: states && Array.from(states.keys()),
                    formatValue: (value) => {
                        const state = states.get(value);
                        if ((!value && states.size === 0) || !state) {
                            return "";
                        }
                        return `${state.stateProvinceName} - ${state.stateProvinceCode}`;
                    },
                };
            },
            width: 200
        },
        {
            headerName: "Licensed",
            field: "Licensed",
            valueFormatter: licenseValueFormatter,
            cellEditor: "agSelectCellEditor",
            cellEditorParams: {
                values: [true, false],
                formatValue: (value) =>
                    value === true ? "Licensed" : "Unlicensed",
            },
            width: 200,
            hide: currentCountry !== "US"
        },
        {
            headerName: "License Number",
            field: "License",
            cellEditorSelector: (params) => {
                return {
                    component: params.data.Licensed
                        ? "agTextCellEditor"
                        : "agSelectCellEditor",
                };
            },
            cellEditorParams: {
                values: licenseNumArr,
            },
            width: 200,
            hide: currentCountry !== "US"
        },
        {
            headerName: "Address",
            field: "Address",
            editable: (params) => params.data.Licensed === true || currentCountry === "CA",
            width: 250
        },
        {
            headerName: "Closest Delivery Location",
            field: "closestDeliveryLocation",
            editable: (params) => !!params.data.closestDeliveryLocation,
            width: 250,
            hide: currentCountry !== "US"
        },
        {
            headerName: "City",
            field: "City",
            editable: (params) => params.data.Licensed === true || currentCountry === "CA",
            width: 150
        },
        {
            headerName: "Zip",
            field: "Zip",
            editable: (params) => params.data.Licensed === true || currentCountry === "CA",
            width: 150
        },
        {
            headerName: "Dealership First Name",
            field: "Name.firstName",
            width: 200
        },
        {
            headerName: "Dealership Middle Name",
            field: "Name.MiddleName",
            width: 200
        },
        {
            headerName: "Dealership Last Name",
            field: "Name.LastName",
            width: 200
        },
        {
            headerName: "PDI Location",
            field: "pdiLocation",
            hide: currentCountry !== "CA",
            width: 320
        },
        {
            headerName: "ID",
            field: "ID",
            hide: currentCountry !== "CA",
            width: 200
        },
        {
            headerName: "Remittance Responsibility",
            field: "remittanceResponsibility",
            cellEditor: "agSelectCellEditor",
            cellEditorParams: {
                values:
                    constantsData &&
                    extractValues(constantsData?.remittanceResponsibility),
            },
            width: 200
        },
        {
            headerName: "Lease Taxes Paid",
            field: "leaseTaxesPaid",
            cellEditor: "agSelectCellEditor",
            cellEditorParams: {
                values:
                    constantsData &&
                    extractValues(constantsData?.leaseTaxesPaid),
            },
            width: 200,
            hide: currentCountry !== "US"
        },
        {
            headerName: "Lease Taxes Remitted",
            field: "leaseTaxesRemitted",
            cellEditor: "agSelectCellEditor",
            cellEditorParams: {
                values:
                    constantsData &&
                    extractValues(constantsData?.leaseTaxesRemitted),
            },
            width: 200,
            hide: currentCountry !== "US"
        },
        {
            headerName: "County",
            field: "county",
            editable: false,
            width: 200,
            hide: currentCountry !== "US"
        },
    ];

    useEffect(() => {
        const country = localStorage.getItem("Country") ?? currentCountry;
        setCurrentCountry(country);
        refreshCountries();
        refreshDealershipEnums();
        refreshDealerships(country);
        refreshStates(iso3Codes[country]);
    }, []);

    const refreshCountries = async () => {
        const countriesCurrencies = await getCountriesCurrencies();
        const countryOptionArr = [];
        countriesCurrencies.map((item) => {
            countries.set(item.countryISO2Code, item);
            const countryOption = {
                label: `${item.countryISO2Code} - ${item.countryName}`,
                value: item.countryISO2Code,
            };
            countryOptionArr.push(countryOption);
        });
        setCountries(countries);
        setCountryOption(countryOptionArr);
    };
    const refreshStates = async (countryISO3Code) => {
        const statesList = await getStates(countryISO3Code);
        states.clear();
        setStates(new Map());
        columnDefs[1].cellEditorParams.values = [];
        gridRef.current.api.setColumnDefs(columnDefs);

        if (statesList.length > 0) {
            statesList.map((item) => {
                states.set(item.stateProvinceCode, item);
            });
            setStates(states);
            columnDefs[1].cellEditorParams.values =
                states && Array.from(states.keys());
            gridRef.current.api.setColumnDefs(columnDefs);
        }
        setStatesList(statesList);
    };

    const refreshDealershipEnums = async () => {
        const enums = await getDealershipEnums();
        setConstantsData(enums);
    };

    const refreshDealerships = async (country) => {
        const dealerships = await getDealerships(country);
        updateLicenseNumArr(dealerships);
        setTableData(dealerships);
    };

    const updateLicenseNumArr = (licensesArr) => {
        let licenseSet = new Set();
        const licenseNumOptionArr = [];
        licensesArr.map((item) => {
            if (item.Licensed) {
                licenseSet.add(item.License);
                licenseNumOptionArr.push({
                    value: item.License,
                    label: item.License,
                });
                setLicenseStateAddresses(
                    licenseStateAddresses.set(item.License, {
                        Address: item.Address,
                        City: item.City,
                        Zip: item.Zip,
                    }),
                );
            }
        });
        setLicenseNumOption(licenseNumOptionArr);
        setLicenseNumArr(Array.from(licenseSet));
    };

    const handleCellValueChanged = (event) => {
        const rowNode = gridRef.current.api.getRowNode(event?.data?._id);
        if (event?.data?.Licensed) {
            if (
                rowNode &&
                event?.column?.colId === "Licensed" &&
                event?.oldValue === false
            ) {
                let updateData = event?.data;
                fnOpenToast(
                    "For licensed state, Address, City & Zip fields are required",
                    "error",
                );
                updateData.License = "";
                updateData.Address = "";
                updateData.City = "";
                updateData.Zip = "";
                rowNode.setData(updateData);
                return;
            }

            if (
                event?.column?.colId === "Address" &&
                !event?.data?.Address.trim()
            ) {
                fnOpenToast(
                    "For licensed state, Address field is required",
                    "error",
                );
                return;
            } else if (
                event?.column?.colId === "City" &&
                !event?.data?.City.trim()
            ) {
                fnOpenToast(
                    "For licensed state, City field is required",
                    "error",
                );
                return;
            } else if (
                event?.column?.colId === "Zip" &&
                !event?.data?.Zip.trim()
            ) {
                fnOpenToast(
                    "For licensed state, Zip field is required",
                    "error",
                );
                return;
            } else if (
                !event?.data?.Name?.firstName.trim() ||
                !event?.data?.Name?.MiddleName.trim() ||
                !event?.data?.Name?.LastName.trim()
            ) {
                fnOpenToast(
                    "Dealership firstName, MiddleName & LastName fields are required",
                    "error",
                );
                return;
            } else if (!event?.data?.remittanceResponsibility.trim()) {
                fnOpenToast(
                    "Remittance responsibility field is required",
                    "error",
                );
                return;
            } else if (
                event?.column?.colId === "License" &&
                licenseNumArr.includes(event?.data?.License)
            ) {
                fnOpenToast("License number should be unique", "error");
                return;
            } else if (
                event?.data?.License.trim() &&
                event?.data?.Address.trim() &&
                event?.data?.City.trim() &&
                event?.data?.Zip.trim()
            ) {
                setRowsUpdated(rowsUpdated.set(event?.data?._id, event?.data));
            }
        } else {
            const licensedStateDetails = licenseStateAddresses.get(
                event.data.License,
            );
            if (licensedStateDetails) {
                event.data.Address = licensedStateDetails.Address;
                event.data.City = licensedStateDetails.City;
                event.data.Zip = licensedStateDetails.Zip;
                if (rowNode) {
                    rowNode.setDataValue(
                        "Address",
                        licensedStateDetails.Address,
                    );
                    rowNode.setDataValue("City", licensedStateDetails.City);
                    rowNode.setDataValue("Zip", licensedStateDetails.Zip);
                }
            }
            setRowsUpdated(rowsUpdated.set(event?.data?._id, event?.data));
        }
    };

    const handleStopEditing = useCallback((event) => {
        if (event?.column?.colId === "Licensed") {
            if (event?.newValue === false) {
                const rowNode = gridRef.current.api.getRowNode(
                    event?.data?._id,
                );
                let updateData = event?.data;
                updateData.License = "";
                updateData.Address = "";
                updateData.City = "";
                updateData.Zip = "";
                rowNode.setData(updateData);
                return;
            }
        }
        if (event?.column?.colId === "License") {
            if (!event?.newValue.trim() && event?.data?.Licensed === true) {
                fnOpenToast("License number is required", "error");
                return;
            }
        }
        if (
            event?.data?.Licensed === true &&
            event?.column?.colId === "Address"
        ) {
            if (!event?.newValue.trim()) {
                fnOpenToast("Address field is required", "error");
                return;
            }
        }
        if (event?.data?.Licensed === true && event?.column?.colId === "City") {
            if (!event?.newValue.trim()) {
                fnOpenToast("City field is required", "error");
                return;
            }
        }
        if (event?.data?.Licensed === true && event?.column?.colId === "Zip") {
            if (!event?.newValue.trim()) {
                fnOpenToast("Zip field is required", "error");
                return;
            }
        }
    }, []);

    const handleClickOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);

        setFormData(prevFormData => {
            const updatedFields = {};
            const fieldsToReset = Object.keys(initialValue);

            fieldsToReset.forEach(field => {
                updatedFields[field] = {
                    ...prevFormData[field],
                    value: "",
                    hasError: false,
                };
            });

            return {
                ...prevFormData,
                ...updatedFields
            };
        });
    };

    const onChange = (e) => {
        const {value, id, name} = e.target;
        setFormData({...formData, [id ?? name]: {value, hasError: false}});
    };

    const handleFormSubmit = async (event) => {
        event.preventDefault();
        try {
            const request = constructRequest(formData);
            await createDealership(request);
            await refreshDealerships(currentCountry);
            fnOpenToast("Dealership Added Successfully", "success");
        } catch (error) {
            notifyError(error);
        } finally {
            handleClose();
        }
    };

    const constructRequest = (formData) => {
        const {
            State,
            Address,
            City,
            Zip,
            remittanceResponsibility,
            Licensed,
            License,
            closestDeliveryLocation,
            leaseTaxesPaid,
            leaseTaxesRemitted,
            PdiLocation,
            ID
        } = formData;

        const request = {
            Country: currentCountry,
            state: State.value,
            Address: Address.value,
            City: City.value,
            Zip: Zip.value,
            Name: {
                firstName: formData["Name.firstName"].value,
                MiddleName: formData["Name.MiddleName"].value,
                LastName: formData["Name.LastName"].value,
            },
            remittanceResponsibility: remittanceResponsibility.value
        };

        if (currentCountry === "US") {
            return {
                ...request,
                Licensed: Licensed.value,
                License: License.value,
                closestDeliveryLocation: closestDeliveryLocation.value,
                leaseTaxesPaid: leaseTaxesPaid.value,
                leaseTaxesRemitted: leaseTaxesRemitted.value
            };
        } else if (currentCountry === "CA") {
            return {
                ...request,
                pdiLocation: PdiLocation.value,
                ID: ID.value
            };
        }
    };

    const handleEnableEdit = () => {
        setEnableEditing(true);
    };

    const handleSaveEdited = () => {
        const editedRows = Array.from(rowsUpdated.values());
        if (editedRows.length === 0) {
            fnOpenToast("Edit one or more records to update!", "error");
            return;
        }
        handleUpdateDealership(editedRows);
        setRowsUpdated(new Map());
    };

    const handleCancelEdit = () => {
        setEnableEditing(false);
        setRowsUpdated(new Map());
        refreshDealerships(currentCountry);
    };

    const handleUpdateDealership = async (editedRows) => {
        const confirm = window.confirm(
            "Are you sure, you want to update these rows ?",
        );
        if (!confirm) {
            return;
        }
        setEnableEditing(false);
        try {
            const updateRequest = {
                updateDealerships: editedRows,
            };
            try {
                const errorOcurred = await updateDealerships(updateRequest);
                !errorOcurred
                    ? fnOpenToast("Dealership Updated Successfully!", "success")
                    : notifyError(
                        errorOcurred?.message || "Something went wrong",
                    );
            } catch (error) {
                notifyError(error);
            }

            await refreshDealerships(currentCountry);
        } catch (error) {
            notifyError(error);
        }
    };

    const defaultColDef = {
        sortable: true,
        filter: true,
        floatingFilter: true,
        editable: enableEditing,
        resizable: true,
        // Show tooltip with dealership description when available
        tooltipValueGetter: (params) => {
            const desc = params?.data?.description;
            return desc && typeof desc === 'string' && desc.trim().length > 0 ? desc : undefined;
        }
    };

    const onFirstDataRendered = useCallback(() => {
        gridRef.current.api.sizeColumnsToFit();
    }, []);

    const onCellEditingStartedCustom = useCallback((params) => {
        if (currentCountry !== params.data.Country) {
            setCurrentCountry(params.data.Country);
        }
    }, []);

    const handleBulkDelete = useCallback(async () => {
        const selectedRows = gridRef.current.api.getSelectedRows();
        if (selectedRows.length === 0) {
            fnOpenToast("Select dealership records to delete !!!", "error");
            return;
        }

        const confirm = window.confirm(
            "Are you sure, you want to delete these rows?",
        );
        if (!confirm) {
            return;
        }

        const _idsToRemove = [];
        selectedRows.map((item) => {
            _idsToRemove.push(item._id);
        });
        const {deletedCount, errors} = await deleteDealerships(_idsToRemove);
        if (deletedCount) {
            fnOpenToast(
                `${deletedCount} Dealership data delete successfully`,
                "success",
            );
            gridRef.current.api.applyTransaction({remove: selectedRows});
        }
        if (errors) {
            errors?.map((item) => {
                fnOpenToast(item?.message, "error");
            });
        }
    }, []);

    const getRowId = useMemo(() => {
        return (params) => {
            return params.data._id;
        };
    }, []);

    const [anchorEl, setAnchorEl] = useState(null);

    const handleActionClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleActionClose = useCallback(() => {
        setAnchorEl(null);
    }, []);

    const handleSetCountry = (event) => {
        const selectedCountry = event.target.value;
        const country = countries.get(selectedCountry);
        localStorage.setItem("Country", selectedCountry);
        setCurrentCountry(selectedCountry);
        refreshDealerships(selectedCountry);
        refreshStates(country?.countryISO3Code);
    };

    // Highlight rows that contain a description so they appear slightly yellow
    const rowClassRules = {
        'has-description': (params) => {
            const desc = params?.data?.description;
            return !!(typeof desc === 'string' ? desc.trim() : desc);
        }
    };

    return (
        <div>
            <style>{`
                /* Slight yellow background for rows that have a description */
                .ag-theme-alpine .ag-row.has-description {
                    background-color: #fff9e6 !important; /* light yellow */
                }
                /* Darker on hover to emphasize */
                .ag-theme-alpine .ag-row.has-description:hover {
                    background-color: #fff2cc !important; /* a bit darker yellow */
                }
            `}</style>
            <div style={{margin: "10px 20px"}}>
                <Breadcrumbs aria-label="breadcrumb">
                    <ReactLink
                        color="inherit"
                        to="/"
                        className="breadcrumb-link"
                    >
                        Dashboard
                    </ReactLink>
                    <Typography color="textPrimary">
                        Dealership Assignment
                    </Typography>
                </Breadcrumbs>
            </div>
            <Box
                display="flex"
                justifyContent="space-between"
                style={{margin: "10px 20px"}}
            >
                <div>
                    <Typography
                        variant="h5"
                        component={"h5"}
                        style={{
                            fontFamily: "GTAmericaMedium",
                            fontSize: "24px",
                            lineHeight: "120%",
                            fontWeight: "500",
                        }}
                    >
                        Dealership Assignment
                    </Typography>
                </div>
                <>
                    <Box
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                    >
                        <div style={{marginRight: "10px"}}>
                            <FormControl variant="outlined">
                                <InputLabel id="demo-simple-select-autowidth-label">
                                    Country
                                </InputLabel>
                                <Select
                                    labelId="demo-simple-select-outlined-label"
                                    id="demo-simple-select-outlined"
                                    value={currentCountry}
                                    onChange={handleSetCountry}
                                    label="Country"
                                >
                                    <MenuItem value={"US"}>US</MenuItem>
                                    <MenuItem value={"CA"}>CA</MenuItem>
                                </Select>
                            </FormControl>
                        </div>
                        <div style={{display: "flex", alignItems: "center"}}>
                            <Button
                                variant="outlined"
                                color="primary"
                                aria-controls="action-menu"
                                aria-haspopup="true"
                                onClick={handleActionClick}
                            >
                                Actions <ExpandMoreIcon/>
                            </Button>
                            <Menu
                                id="action-menu"
                                anchorEl={anchorEl}
                                keepMounted
                                open={Boolean(anchorEl)}
                                onClose={handleActionClose}
                            >
                                <MenuItem
                                    onClick={handleEnableEdit}
                                    disabled={enableEditing}
                                >
                                    <EditIcon
                                        fontSize="small"
                                        style={{marginRight: "5px"}}
                                    />{" "}
                                    Enable Edit
                                </MenuItem>
                                <MenuItem
                                    onClick={handleSaveEdited}
                                    disabled={!enableEditing}
                                >
                                    <CheckCircleOutlineIcon
                                        fontSize="small"
                                        style={{marginRight: "5px"}}
                                    />{" "}
                                    Save Changes
                                </MenuItem>
                                <MenuItem
                                    onClick={handleCancelEdit}
                                    disabled={!enableEditing}
                                >
                                    <RedoIcon
                                        fontSize="small"
                                        style={{marginRight: "5px"}}
                                    />{" "}
                                    Cancel Edit
                                </MenuItem>
                                <MenuItem
                                    onClick={handleClickOpen}
                                    disabled={enableEditing}
                                >
                                    <AddCircleOutlineIcon
                                        fontSize="small"
                                        style={{marginRight: "5px"}}
                                    />{" "}
                                    Add Dealer
                                </MenuItem>
                                <MenuItem
                                    onClick={handleBulkDelete}
                                    disabled={enableEditing}
                                >
                                    <DeleteOutlineIcon
                                        fontSize="small"
                                        style={{marginRight: "5px"}}
                                    />{" "}
                                    Delete Selected Dealer(s)
                                </MenuItem>
                            </Menu>
                        </div>
                    </Box>
                </>
            </Box>
            <table
                style={{
                    margin: "0 20px",
                    width: "calc(100% - 40px)",
                    height: "calc(100vh - 170px)",
                }}
            >
                <tbody>
                <tr>
                    <td style={{border: "1px solid #babfc7"}}>
                        <div
                            className="ag-theme-alpine"
                            style={{
                                height: "100%",
                                width: "100%",
                            }}
                        >
                            <AgGridReact
                                rowSelection="multiple"
                                ref={gridRef}
                                rowData={tableData}
                                columnDefs={columnDefs}
                                defaultColDef={defaultColDef}
                                rowClassRules={rowClassRules}
                                tooltipShowDelay={200}
                                tooltipHideDelay={2147483647}
                                tooltipMouseTrack={true}
                                onFirstDataRendered={onFirstDataRendered}
                                onCellValueChanged={handleCellValueChanged}
                                frameworkComponents={frameworkComponents}
                                stopEditingWhenCellsLoseFocus={true}
                                enableCellChangeFlash={true}
                                onCellEditingStarted={
                                    onCellEditingStartedCustom
                                }
                                onCellEditingStopped={handleStopEditing}
                                getRowId={getRowId}
                            />

                            {constantsData && (
                                <CreateDealershipDialog
                                    country={currentCountry}
                                    statesList={statesList}
                                    open={open}
                                    handleClose={handleClose}
                                    data={formData}
                                    onChange={onChange}
                                    handleFormSubmit={handleFormSubmit}
                                    constantsData={constantsData}
                                    countryOption={countryOption}
                                    countriesMap={countries}
                                    licenseNumArr={licenseNumOption}
                                    licenseStateAddressesMap={
                                        licenseStateAddresses
                                    }
                                    dealers={tableData}
                                />
                            )}
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    );
}

export default Dealerships;

